import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import type { IPolicies } from '@/modules/policies/helpers';
import { type CMSApiBase, createCmsUrl } from './base';

export interface TermsAndConditionsApi extends CMSApiBase, IPolicies {
  title: string;
  titleH1: string;
  effectiveFrom: string;
  lastUpdated: string;
}

export const getTermsAndConditionsUrl = (lang: string) =>
  createCmsUrl({
    path: 'term-and-condition',
    queryData: { ...getCMSLocale(lang) },
  });

export const fetchTermsAndConditions = async (lang: string) =>
  fetcherCMS<TermsAndConditionsApi>(getTermsAndConditionsUrl(lang));
